import { Link } from 'react-router-dom';

export default function SiteFooter() {
  return (
    <footer className="border-t border-orange-100 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-9 md:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#20150f] text-orange-400">
                <i className="ri-music-2-fill" />
              </span>
              <div>
                <div className="font-heading text-lg font-black text-[#2a1b13]">PARTITURAS</div>
                <div className="text-[10px] font-bold uppercase tracking-[0.12em] text-orange-600">
                  pratique até dominar
                </div>
              </div>
            </div>
            <p className="mt-3 max-w-md text-xs leading-relaxed text-slate-500">
              Ferramenta de apoio para iniciantes praticarem leitura musical. Não substitui o professor.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm font-semibold text-slate-600">
            <Link to="/aulas" className="hover:text-orange-600">Aulas</Link>
            <Link to="/teste-de-nivel" className="hover:text-orange-600">Teste de nível</Link>
            <Link to="/entrar" className="hover:text-orange-600">Entrar</Link>
          </div>
        </div>

        <div className="mt-7 flex flex-col gap-2 border-t border-orange-100 pt-5 text-[11px] text-slate-400 sm:flex-row sm:justify-between">
          <span>© 2026 Partituras · Versão de testes</span>
          <span>Progresso com conta e backup automático</span>
        </div>
      </div>
    </footer>
  );
}
